angular.module('impactx.uploadservicebrowser').controller('RegisterDialogCtrl', ['$scope', '$mdDialog', 'TranslationService', 'themeFactory',
    'header', 'inputLabel', RegisterDialogCtrl]);

function RegisterDialogCtrl($scope, $mdDialog, TranslationService, themeFactory, header, inputLabel)
{
    $scope.saveLabel = TranslationService.get("save");
    $scope.abortLabel = TranslationService.get("abort");
    $scope.theme = themeFactory.getTheme();
    $scope.header = header;
    $scope.inputLabel = inputLabel;
    $scope.email = {value: ""};
    var self = this;

    self.cancel = function() {
        $mdDialog.cancel();
    };
    self.answer = function() {
        $mdDialog.hide($scope.email.value);
    };
}